import { CREDIT_NOTE_REQUEST, CREATE_CREDIT_NOTE, GET_CREDIT_NOTES, UPDATE_CREDIT_NOTE, DELETE_CREDIT_NOTE, GET_CREDIT_NOTES_PAGE,
  CREDIT_NOTE_REQUEST_FAILURE, CREDIT_NOTE_REQUEST_SUCCESS } from '../types';

const initialState = {
  creditNotes: [],
  creditNotesPage: [],
  page: 1,
  pageSize: 10,
  search: '',
  where: {},
  total: 0,
  loading: false,
  error: null,
};

const creditNoteReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREDIT_NOTE_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_CREDIT_NOTES: {
      return {
        ...state,
        creditNotes: [...action.payload],
        loading: false,
        error: null
      }
    }
    case GET_CREDIT_NOTES_PAGE: {
      const { data, total, page, pageSize, search, where } = action.payload || {};
      return {
        ...state,
        creditNotesPage: [...data],
        total,
        page,
        pageSize,
        search: search || '',
        where: where || {},
        loading: false,
        error: null
      }
    }
    case CREATE_CREDIT_NOTE: {
      return {
        ...state,
        creditNotes: [action.payload, ...state.creditNotes],
        loading: false,
        error: null
      };
    }
    case UPDATE_CREDIT_NOTE: {
      const creditNotesData = state.creditNotes.slice(0);
      const uIndex = creditNotesData.findIndex((data) => data.id === action.payload.id);
      creditNotesData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        creditNotes: [ ...creditNotesData ],
        loading: false,
        error: null
      };
    }
    case DELETE_CREDIT_NOTE: {
      const creditNotes = state.creditNotes?.slice(0);
      const index = creditNotes.findIndex((data) => data.id === action.id);
      if (index > -1) {
        creditNotes.splice(index, 1);
      }
      return {
        ...state,
        creditNotes: [...creditNotes],
        loading: false,
        error: null
      }
    }
    case CREDIT_NOTE_REQUEST_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null
      }
    }
    case CREDIT_NOTE_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default creditNoteReducer;